import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { ToastContainerModule, ToastrModule } from 'ngx-toastr'

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot({
      easeTime: 400,
      positionClass: 'toast-top-full-width',
      timeOut: 5000,
      maxOpened: 20,
    }),
    ToastContainerModule,
  ],
})
export class AlertModule {}
